import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    lastProyect: null,
    proyects: [],
    labelText: 'Último proyecto'
}

export const lastProyectSlice = createSlice({
    name: 'proyects',
    initialState,
    reducers: {
        setLastProyect: (state, action) => {
            state.lastProyect = action.payload
        },
        setProyects: (state, action) => {
            state.proyects = action.payload
        },
        setLabelText: (state, action) => {
            state.labelText = action.payload
        }
    }
})

export const { setLastProyect, setProyects, setLabelText } = lastProyectSlice.actions
export default lastProyectSlice.reducer
